import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FilterControl} from "../interface/filter-control";

@Component({
	selector: 'fb-filter-toggle-control',
	templateUrl: './filter-toggle-control.component.html',
	styleUrls: ['./filter-toggle-control.component.scss']
})
export class FilterToggleControlComponent {

	@Input()
	public control: FilterControl = {} as FilterControl;
	@Output()
	public onControlChange: EventEmitter<null> = new EventEmitter<null>();


	public onChange($event: any): void {
		if(this.control.cohort)
			this.control.cohort.options[0].active = $event.target.checked;
		this.onControlChange.next(null);
	}
}
